/*!
 * Copyright © 2020-2023. Verizon Connect Ireland Limited. All rights reserved.
 */

import { FormControl } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';

export class NotPristineAndDirtyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl<string> | null): boolean {
    // IE11 does not handle pristine/dirty/touched states correctly when a placeholder is present and marks the control
    // as dirty and not pristine. Marking the control as pristine when the value is empty means we do not display errors
    // till the user starts typing in the input field and the errors are not displayed if the user clears the input field.
    if (control && control.value === '') {
      control.markAsPristine();
    }

    return !!(control && control.invalid && !control.pristine && control.dirty);
  }
}
